import React from "react";
import { Button, CircularProgress, createFilterOptions } from "@mui/material";

export const dominioFilterOptions = createFilterOptions({
  stringify: (option) => `${option?.dominio || ""} ${option?.id ?? ""} ${option?.bd || ""}`,
});

export function BusyButton({
  loading = false,
  disabled,
  startIcon,
  children,
  loadingText,
  ...props
}) {
  const effectiveDisabled = disabled ?? loading;
  const effectiveStartIcon = loading ? (
    <CircularProgress size={16} />
  ) : (
    startIcon
  );

  return (
    <Button {...props} disabled={effectiveDisabled} startIcon={effectiveStartIcon}>
      {loading && loadingText ? loadingText : children}
    </Button>
  );
}
